module.exports = __webpack_public_path__ + "img/Haier.f289984a.jpg";